import React from "react";
import { Trans, useTranslation } from "react-i18next";
const Agree = ({ groupName, streamName }) => {
  const { t } = useTranslation("integrations");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, t("aws_kinesis_setup_agree.description")), /* @__PURE__ */ React.createElement("ol", null, /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement(Trans, { t, i18nKey: "aws_kinesis_setup_agree.step_stream", components: { strong: /* @__PURE__ */ React.createElement("strong", null) } })), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "aws_kinesis_setup_agree.step_role",
      values: { groupName, streamName },
      components: { strong: /* @__PURE__ */ React.createElement("strong", null) }
    }
  )), /* @__PURE__ */ React.createElement("li", null, t("aws_kinesis_setup_agree.step_subscription"))));
};
export default Agree;
